export class Constants {

    // UAT url----

    static UAT_DOMAIN = "https://uat.v3.api.emedhub.in/v2/"
    static UAT_BASE_DOMAIN =  "https://uat.v3.api.emedhub.in/"
    static CLIENT_AUTH_TOKEN = "Api-Key KBaElbkM.og8P0oBM7qT478DUlf4iJoWpOJ1Nb4on"

    // Beta url----

    // static UAT_DOMAIN = "https://api.emedhub.in/v2/"
    // static UAT_BASE_DOMAIN = "https://api.emedhub.in/"
    // static CLIENT_AUTH_TOKEN = "Api-Key OqilVNHV.qDEQiDXOoetOXCag8zWPh5if3pBD7Wjo"

    static DOMAIN = this.UAT_DOMAIN;
    static BASE_DOMAIN = this.UAT_BASE_DOMAIN;

    static AGORA_CALL_END_POST = this.DOMAIN + "telemedicine/video-call/end/";
    static CLIENT_DOCTOR_DETAILS_GET = this.BASE_DOMAIN + "apikey/doctors/details/client/";
    static CLIENT_SIDE_APPOINTMENT_POST = this.BASE_DOMAIN + "apikey/appointment/request/from/client/";
    static PAYMENT_RESPONSE_GET = this.DOMAIN + "telemedicine/patient/payment/callback/razor/";
    static VIRTUAL_LINK_CALL_JOIN_POST = this.DOMAIN + "telemedicine/virtual-link/telemedicine-call/"
}